module.exports = __webpack_public_path__ + "media/images/logos/external/glassdoor_logo_black-590fc97e5f0274c4e05b0760fc6d4a33.svg";